import type { TaxResidence } from '@/features/tax-residency/schema';
import { taxIdentificationNumberFormatsQueryOptions } from '@/hooks/queries/use-tax-identification-number-formats';
import { queryClient } from '@/lib/query-client';
import { reportTaxIdentificationNumberFormatError } from '@/utils/tax-identification-number';

// For a step's leave guard: the stepper's own validation has no failure callback, so a rejected TIN is reported as the step is left
export const reportTaxResidenceFormatErrors = async (taxResidences: TaxResidence[]) => {
  const { validate } = await queryClient.ensureQueryData(taxIdentificationNumberFormatsQueryOptions);

  for (const { country, taxId } of taxResidences) {
    reportTaxIdentificationNumberFormatError({ country, taxId, validate });
  }
};
